import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  makeStyles,
  Divider,
  Typography,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { SIREN_CONFIG } from "config.js";
import md5 from 'md5';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { loadCaregiverRoomList } from "utils/LoadConfiguration";
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import koLocale from 'date-fns/locale/ko';
import moment from 'moment';
import {timeStringToDate} from '../../utils/helperFunc';



const CaregiverUpdateForm = (props) => {
  const { className, history, caregiverInfo, ...rest } = props;
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [errorText, setErrorText] = useState('');

  const [roomList, setRoomList] = useState([]);

  const [checkedState, setCheckedState] = useState([]);
  const facility_id = useSelector((store) => store.user.facility_id);

  const [newStartTime, setNewStartTime] = React.useState(() => timeStringToDate(caregiverInfo.alarmStartTime));
  const [newEndTime, setNewEndTime] = React.useState(() => timeStringToDate(caregiverInfo.alarmEndTime));


  const handleSubmit = (event, values) => {
    event.preventDefault();

    let sStartTime = "";
    let sEndTime = "";

    try {
      sStartTime = moment(newStartTime).format('HH:mm');
      sEndTime = moment(newEndTime).format('HH:mm');
    } catch (err) {
      alert('The alarm time is wrong.');
      return;
    }


    let newRoomList = [];
    roomList.map((roomInfo, index) => {
      roomInfo.isMine = checkedState[index] === true ? 1 : 0;
      newRoomList.push(roomInfo);
    });


    fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/updateCaregiverRoom`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        caregiverId: caregiverInfo.caregiverId,
        caregiverRoomList: newRoomList,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {

          fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/updateCaregiver`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              facility_id: facility_id,
              caregiver_id: caregiverInfo.caregiverId,
              caregiver_name: values.caregiverName,
              caregiver_tel_no: values.caregiverTelNo,
              alarm_start_time: sStartTime,
              alarm_end_time: sEndTime
            }),
          })
          .then((response) => {
            return response.json();
          })
          .then((responseData) => {
            if (responseData.resultCode === "000") {
              alert(formatMessage({id:'update_successful'}));

              setTimeout(() => {
                history.goBack();
              }, 500);
            } else {
              //에러
              console.log(responseData.resultMessage);
              alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
            }
          })
          .catch((error) => {
            console.error(error);
            alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
          });

        } else {
          //에러
          console.log(responseData.resultMessage);
          alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
      });

    return;
  };


  const handlePasswordChange1 = (event) => {
    setPassword1(event.target.value);
  }

  const handlePasswordChange2 = (event) => {
    setPassword2(event.target.value);
  }

  const handleUpdatePassword = (event) => {
    setErrorText('');

    if (password1.length === 0) {
      setErrorText(formatMessage({id:'new_password_required'}));
      return;
    }

    if (password2.length === 0) {
      setErrorText(formatMessage({id:'confirm_password_required'}));
      return;
    }

    if (password1 !== password2) {
      setErrorText(formatMessage({id:'not_match_password'}));
      return;
    }


    fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/updateCaregiverPassword`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        caregiver_id: caregiverInfo.caregiverId,
        caregiver_password: md5(password1),
      }),
    })
    .then((response) => { return response.json(); })
    .then((responseData) => {
      // console.error("responseData:" + responseData);

      if (responseData.resultCode === "000") {
        alert(formatMessage({id:'change_password_successful'}));
      } else {
        //에러
        alert(`${formatMessage({id:'change_password_failed'})}.\n${responseData.resultMessage}\n${responseData.message}`);//pass the test.
      }
    })
    .catch((error) => {
      console.error(error);
      alert(`${formatMessage({id:'change_password_failed'})}.\n${error.message}`);//pass the test.
    });

  }


  const handleDelete = (event) => {
    // event.preventDefault();

    fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/deleteCaregiver`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        caregiver_id: caregiverInfo.caregiverId,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {
          alert(formatMessage({id:'delete_successful'}));

          setTimeout(() => {
            history.goBack();
          }, 500);
        } else {
          //에러
          console.log(responseData.message);
          alert(`${formatMessage({id:'delete_failed'})}.\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(`${formatMessage({id:'delete_failed'})}.\n${error.message}`);
      });
  }


  const cancelConfirm = () => console.log("delete canceled.");


  const useConfirm = (msg = "", onConfirm, onCancel) => {
		if (!onConfirm || typeof onConfirm !== "function") return;
		if (!onCancel || typeof onCancel !== "function") return;

		const doDelete = () => {
			if(window.confirm(msg)){
				onConfirm();
			} else {
				onCancel();
			}
		}

		return doDelete;
	};


  const confirmDelete = useConfirm(formatMessage({id:'question_delete'}),
    handleDelete,
    cancelConfirm);


  const handleBack = () => {
    history.goBack();
  };

  const handleChange2 = (position) => {

    let updateCheckedState = checkedState.map( (item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updateCheckedState);
  }


  useEffect(() => {


    async function loadRoomInfo() {
      let rooms = await loadCaregiverRoomList(facility_id, caregiverInfo.caregiverId)

      setRoomList(rooms);

      let newCheckedState = new Array(rooms.length).fill(false);

      rooms.map( (roomInfo, index) => {
        let isMine = roomInfo.isMine;
        newCheckedState[index] = (isMine === 1 ? true : false);
      });

      setCheckedState(newCheckedState);
    }

    loadRoomInfo();
  }, []);


  return (
    <Formik
      initialValues={{
        caregiverId: caregiverInfo.caregiverId,
        caregiverName: caregiverInfo.caregiverName,
        // caregiverPassword: caregiverInfo.caregiverPassword,
        caregiverTelNo: caregiverInfo.caregiverTelNo,
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.root, className)}
          onSubmit={(e) => handleSubmit(e, values)}
        >
          <Card>
            <CardHeader
              className={classes.card_header}
              title={formatMessage({ id: 'caregiver_info' })}
              titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }}
            />

            <CardContent>
              <Grid container spacing={2}>
                <Grid item md={2} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiverId && errors.caregiverId)}
                    fullWidth
                    helperText={touched.caregiverId && errors.caregiverId}
                    label="ID"
                    disabled
                    name="caregiverId"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    value={values.caregiverId}
                    variant="outlined"
                    inputProps={{ maxLength: 8 }}
                  />
                </Grid>
                <Grid item md={10} xs={12} />

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiverName && errors.caregiverName)}
                    fullWidth
                    helperText={touched.caregiverName && errors.caregiverName}
                    label={formatMessage({ id: 'caregiver_name' })}
                    name="caregiverName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    value={values.caregiverName}
                    variant="outlined"
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiverTelNo && errors.caregiverTelNo)}
                    fullWidth
                    helperText={touched.caregiverTelNo && errors.caregiverTelNo}
                    label={formatMessage({ id: 'caregiver_tel' })}
                    name="caregiverTelNo"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.caregiverTelNo}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>
              </Grid>


              <Grid container spacing={2} style={{ paddingTop: 10 }}>

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiverPassword && errors.caregiverPassword)}
                    fullWidth
                    helperText={touched.caregiverPassword && errors.caregiverPassword}
                    label={formatMessage({ id: 'password' })}
                    name="caregiverPassword"
                    type="password"
                    onBlur={handleBlur}
                    onChange={handlePasswordChange1}
                    value={values.caregiverPassword}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiverPasswordConfirm && errors.caregiverPasswordConfirm)}
                    fullWidth
                    helperText={touched.caregiverPasswordConfirm && errors.caregiverPasswordConfirm}
                    label={formatMessage({ id: 'password_confirm' })}
                    name="caregiverPasswordConfirm"
                    type="password"
                    onBlur={handleBlur}
                    onChange={handlePasswordChange2}
                    value={values.caregiverPasswordConfirm}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>

                <Button
                  variant="outlined"
                  size="large"
                  color="secondary"
                  onClick={handleUpdatePassword}
                  className={classes.action}
                >
                  <FormattedMessage id="password_change" />
                </Button>
              </Grid>


              <Grid container spacing={2} style={{ marginTop: theme.spacing(2) }}>

                <Grid item md={6} xs={12}>
                  <div className={classes.input_container}>
                    <MuiThemeProvider theme={theme}>

                      <Typography variant="body1" style={{ marginRight: '20px' }}>
                        <FormattedMessage id="caregiver_alarm_recv_time" />
                      </Typography>

                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={koLocale}>
                        <TimePicker
                          label={formatMessage({ id: 'caregiver_alarm_recv_start_time' })}
                          value={newStartTime}
                          onChange={(newValue) => setNewStartTime(newValue)}
                          ampm={false} // 24시간제
                          renderInput={(params) => <TextField {...params} />}
                        />
                        <Typography variant="body1" style={{ marginLeft: '20px', marginRight: '20px' }}>~</Typography>

                        <TimePicker
                          label={formatMessage({ id: 'caregiver_alarm_recv_end_time' })}
                          value={newEndTime}
                          onChange={(newValue) => setNewEndTime(newValue)}
                          ampm={false} // 24시간제
                          renderInput={(params) => <TextField {...params} />}
                        />

                      </LocalizationProvider>

                    </MuiThemeProvider>
                  </div>
                </Grid>

              </Grid>


              <Divider className={classes.divider} />


              <Grid container spacing={2}>
                <Grid item md={12} xs={12} style={{marginLeft: theme.spacing(8), marginRight: theme.spacing(8)}} >

                  <CardHeader
                    className={classes.card_sub_header}
                    title={formatMessage({ id: 'caregiver_charge_room_list' })}
                    titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }}/>

                  <FormControl sx={{ m: 3 }} style={{ marginTop: theme.spacing(2) }} component="fieldset" variant="standard" >
                    {/* <FormLabel component="">담당 병실 리스트</FormLabel> */}
                    <FormGroup row={true}>

                      {roomList.map((roomInfo, index) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkedState.length == 0 ? false : checkedState[index]}
                              onChange={() => handleChange2(index)}
                              name={roomInfo.roomName}
                              sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                            />
                          }
                          label={<Typography variant="subtitle1" className={classes.checkbox_label}>{roomInfo.roomName}</Typography>}
                          style={{marginRight:'40px'}}
                        />
                      ))}


                    </FormGroup>

                  </FormControl>

                </Grid>
              </Grid>


              <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                  <Typography align="center" color="error" variant="body1" noWrap={true}>
                    {errorText}
                  </Typography>
                </Grid>
              </Grid>


              <Divider className={classes.divider}/>

              <Grid container md={12} className={classes.action}>
                <Grid item md={8} xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    size="large"
                    disabled={isSubmitting}
                    className={classes.action}
                  >
                    <FormattedMessage id="update" />
                  </Button>

                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleBack}
                    className={classes.action}
                  >
                    <FormattedMessage id="cancel" />
                  </Button>

                </Grid>

                <Grid item align="right" md={4} xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    className={classes.action}
                    onClick={confirmDelete}
                  >
                    <FormattedMessage id="delete" />
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  );
};

CaregiverUpdateForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default CaregiverUpdateForm;


const theme = createTheme({
  overrides: {
    MuiInputBase: {
      input: {
        //   background: '#dd7711',
        //   padding: 10,
        fontSize: '16px',
      },
    },
  },
})


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  card_sub_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.grey.main,
    marginTop: theme.spacing(4),
    borderRadius: 6,
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  textField: {
    marginLeft : theme.spacing(1),
    maringRight: theme.spacing(1),
    width: 100,
  },
  input_container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  checkbox_label: {
    // marginTop: theme.spacing(2),
    // fontSize:16,
  }
}));
